import { render } from "./GamesView.vue?vue&type=template&id=1d43217f&scoped=true"
import script from "./GamesView.vue?vue&type=script&lang=js"
export * from "./GamesView.vue?vue&type=script&lang=js"

import "./GamesView.vue?vue&type=style&index=0&id=1d43217f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d43217f"]])

export default __exports__